var heading_default = {
  "fontElementMap": "Fo2zV",
  "elementSpacing": "VU8Xt",
  "headerOne": "tK5Ax VU8Xt",
  "headerTwo": "_5qXiZ VU8Xt",
  "headerThree": "bbHr5 VU8Xt",
  "headerFour": "jkYR0 VU8Xt",
  "headerFive": "_5b8rP VU8Xt",
  "headerSix": "iClvA VU8Xt",
  "child": "r4IGM"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
